import { stats } from "@/mocks/site";

export default function StatsBand() {
  return (
    <div className="relative z-10 w-full px-4 md:px-6">
      <div className="-mt-24 rounded-lg border border-background-200 bg-background-50 p-5 md:-mt-28 md:p-7">
        <div className="grid grid-cols-2 gap-5 lg:grid-cols-4">
          {stats.map((item) => (
            <div key={item.label} className="flex flex-col items-start gap-1 border-l-2 border-accent-200 pl-4">
              <p className="font-heading text-2xl text-foreground-950 md:text-3xl">
                {item.value}
                <span className="ml-0.5 font-label text-sm text-foreground-500">{item.suffix}</span>
              </p>
              <p className="text-xs text-foreground-600 md:text-sm">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}